import React from 'react'
import Banner from '../Banner';

const Governance = () => {
  return (
    <div>
      <Banner name={"Governance"} Title={"Governance"} />
    </div>
  );
}

export default Governance
